// src/utils/geo.js

export const LATAM = [
  // Core LATAM
  "AR",
  "BO",
  "BR",
  "CL",
  "CO",
  "CR",
  "CU",
  "DO",
  "EC",
  "SV",
  "GT",
  "HN",
  "MX",
  "NI",
  "PA",
  "PY",
  "PE",
  "PR",
  "UY",
  "VE",
  // Extended Caribbean & Territories
  "BZ",
  "GF",
  "GY",
  "SR",
  "AI",
  "AG",
  "AW",
  "BS",
  "BB",
  "BM",
  "BQ",
  "VG",
  "KY",
  "CW",
  "DM",
  "GD",
  "GP",
  "HT",
  "JM",
  "MQ",
  "MS",
  "BL",
  "KN",
  "LC",
  "MF",
  "PM",
  "VC",
  "SX",
  "TT",
  "TC",
];

const TRIAL_ONLY = new Set(["US", "CA", ...LATAM]);

export function isTrialOnly(cc) {
  if (!cc) return false;
  return TRIAL_ONLY.has(String(cc).toUpperCase());
}

export function getBootstrappedCC() {
  if (typeof window === "undefined") return "";
  // Prefer SSR-injected window var
  var v = (window.__DF_CC || "").toString().toUpperCase();
  if (v) return v;
  // Fallback: cookie
  try {
    var c =
      ("; " + document.cookie).split("; df_cc=").pop().split(";")[0] || "";
    return c.toUpperCase();
  } catch (_) {
    return "";
  }
}

/* ------------------------------------------------------------------ */
/*  HERO CTA GEO MAPPING                                              */
/* ------------------------------------------------------------------ */

// Core markets
const UK = new Set(["GB", "UK"]);

const NORDICS = new Set(["DK", "FI", "NO", "SE", "IS"]);

const BENELUX = new Set(["BE", "NL", "LU"]);

const DACH = new Set(["DE", "AT", "CH"]);

// Rest of Europe (excluding DACH, Benelux, Nordics, UK)
const REST_OF_EUROPE = new Set([
  "FR",
  "ES",
  "PT",
  "IT",
  "IE",
  "PL",
  "CZ",
  "SK",
  "HU",
  "SI",
  "HR",
  "RO",
  "BG",
  "GR",
  "EE",
  "LV",
  "LT",
  "CY",
  "MT",
]);

const US_CA = new Set(["US", "CA"]);
const LATAM_SET = new Set(LATAM);

/**
 * Returns:
 *  - geoParam: string ('uk', 'de', 'dk', 'roe', 'row', 'us', etc.)
 *  - hasSecondary: boolean (true for core markets, false otherwise)
 *
 * Mapping (per your spec):
 *  A. Core markets (DACH, Benelux, Nordics, UK) → dual CTAs
 *  B. Rest of Europe (excluding those) → dual CTAs (launched December 2025 - 3rd week), geo=roe
 *  C. Rest of World (excluding US, CA, LATAM) → primary only, geo=row
 *  D. US/CA/LATAM → primary only, geo=us
 */
export function getHeroGeoConfig(cc) {
  const country = (cc || "").toUpperCase();

  // Fallback: unknown country -> treat as Rest of World
  if (!country) {
    return {
      geoParam: "row",
      hasSecondary: false,
    };
  }

  // --- CORE MARKETS: dual CTAs ---

  // 1. UK
  if (UK.has(country)) {
    return {
      geoParam: "uk",
      hasSecondary: true,
    };
  }

  // 2. Nordics → geo param = country code lowercased
  if (NORDICS.has(country)) {
    return {
      geoParam: country.toLowerCase(), // dk, fi, no, se, is
      hasSecondary: true,
    };
  }

  // 3. Benelux
  if (BENELUX.has(country)) {
    return {
      geoParam: country.toLowerCase(), // be, nl, lu
      hasSecondary: true,
    };
  }

  // 4. DACH
  if (DACH.has(country)) {
    return {
      geoParam: country.toLowerCase(),
      hasSecondary: true,
    };
  }

  // --- REST OF EUROPE (ROE) ---
  if (REST_OF_EUROPE.has(country)) {
    return {
      geoParam: "roe",
      hasSecondary: true,
    };
  }

  // --- US / CA / LATAM -> geo=us ---
  if (US_CA.has(country) || LATAM_SET.has(country)) {
    return {
      geoParam: "us",
      hasSecondary: false,
    };
  }

  // --- Everything else -> Rest of World (ROW) ---
  return {
    geoParam: "row",
    hasSecondary: false,
  };
}
